import { EvaluationReport } from '@spike/report-model';

export const hasAtLeastOneFinalResultSelected = (report: EvaluationReport | null): boolean => {
    if (!report) return false;

    const finalResults = [report.finalResultGrooming, report.finalResultDaycare, report.finalResultBoarding];

    return finalResults.some(result => result === 'pass' || result === 'fail');
};
